module.exports = __webpack_public_path__ + "media/36.eddd44c9.mp3";